import React, { useState } from "react";
import type { ReactNode } from "react";

import { Phase } from "../types";
import type { FlowMode } from "../types";

import type { ScoreData, BriefData } from "../services/api";

import { ConsultationContext } from "./ConsultationContext";
import type { ModalConfig } from "./ConsultationContext";

export const ConsultationProvider: React.FC<{
  children: ReactNode;
  mouthRef: React.RefObject<HTMLDivElement | null>;
}> = ({ children, mouthRef }) => {
  const [scoreData, setScoreData] = useState<ScoreData | null>(null);
  const [briefData, setBriefData] = useState<BriefData | null>(null);
  const [flowMode, setFlowMode] = useState<FlowMode>("both");
  const [briefingDone, setBriefingDone] = useState(false);
  const [phase, setPhase] = useState<Phase>(Phase.IDLE);
  const [isThinking, setIsThinking] = useState(false);
  const [modalConfig, setModalConfig] = useState<ModalConfig>({
    isOpen: false,
    title: "",
    message: "",
    showProgress: false,
  });

  const value = React.useMemo(
    () => ({
      scoreData,
      setScoreData,
      briefData,
      setBriefData,
      flowMode,
      setFlowMode,
      briefingDone,
      setBriefingDone,
      phase,
      setPhase,
      isThinking,
      setIsThinking,
      modalConfig,
      setModalConfig,
      mouthRef,
    }),
    [
      scoreData,
      briefData,
      flowMode,
      briefingDone,
      phase,
      isThinking,
      modalConfig,
      mouthRef,
      setScoreData,
      setBriefData,
      setFlowMode,
      setPhase,
      setIsThinking,
      setModalConfig,
    ],
  );

  return (
    <ConsultationContext.Provider value={value}>
      {children}
    </ConsultationContext.Provider>
  );
};
